var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { SOCIAL_LOGIN_LAYOUTS, socialLoginFactory, } from './SocialLogin';
import { setRenewModal } from '../utils/renewModal';
import { Icon } from '@food/ui/build/dist/src/icons';
import { Modal, ModalLayouts } from '@food/ui/build/dist/src/Modal2';
import { registerClass } from '@food/css-manager';
import { track } from '@food/tracking';
import { isRenew } from '../utils/misc';
import { getLoginType, logout } from '../logic/auth';
import { authTrackOverride } from '../utils/track';
import { event } from 'react-ga';
var modalCloseIcon = registerClass(function (t) { return "\n\tz-index: " + t.zIndexes.P5_TopModal + ";\n\tposition: absolute;\n\ttop: " + t.ratios.s + "em;\n\tright: " + t.ratios.s + "em;\n\tcolor: " + t.colors.ink + ";\n\ttext-decoration: none;\n"; });
var RenewModal = /** @class */ (function (_super) {
    __extends(RenewModal, _super);
    function RenewModal(props) {
        var _this = _super.call(this, props) || this;
        _this.open = function (openArgs) {
            // avviso analytics che la modale si e' aperta
            event({
                category: 'User',
                action: 'Open sign in popup',
            });
            track(__assign(__assign({}, authTrackOverride), { action: { type: 'auth_modal_toggle', open: true } }));
            if (_this.state.open === false) {
                _this.setState({ open: true, openArgs: openArgs });
            }
            // il catch vuoto serve per sovrascrivere l'handler di default di js, il quale restituisce un errore
            // che verrebbe poi segnalato a sentry, inutilmente
            if (_this.loginPromise === null) {
                _this.loginPromise = new Promise(function (resolve, reject) { return (_this.fakeDeferred = { resolve: resolve, reject: reject }); });
                _this.loginPromise.catch(function () { });
            }
            return _this.loginPromise;
        };
        // questo metodo contiene una buona parte delle bad practices possibili con React
        _this.close = function () {
            var onClose = _this.props.onClose;
            var openArgs = _this.state.openArgs;
            var wasUpdate = !!((openArgs === null || openArgs === void 0 ? void 0 : openArgs.upgradeRole) || (openArgs === null || openArgs === void 0 ? void 0 : openArgs.instantUpgradeRole));
            track(__assign(__assign({}, authTrackOverride), { action: { type: 'auth_modal_toggle', open: false } }));
            if (onClose) {
                onClose(wasUpdate);
            }
            _this.setState({ open: false });
        };
        // questo metodo viene usato quando si clicca la "x" in modali di accesso o di rinnovo
        _this.failedCloseHandler = function () {
            var _a;
            if (_this.loginPromise) {
                var error = new Error('Renew chiuso / errato');
                track(__assign(__assign({}, authTrackOverride), { type: 'auth_aborted' }));
                (_a = _this.fakeDeferred) === null || _a === void 0 ? void 0 : _a.reject(error);
            }
            _this.loginPromise = null;
            if (isRenew()) {
                logout();
            }
            _this.close();
        };
        // questo metodo invece serve, al contrario di quello precedente, nel caso di chiusure quando si propone
        // un upgrade ai consumer
        _this.upgradeCloseHandler = function () {
            _this.close();
        };
        _this.successfulLoginHandler = function () {
            var _a;
            (_a = _this.fakeDeferred) === null || _a === void 0 ? void 0 : _a.resolve(true);
            _this.loginPromise = null;
            _this.close();
        };
        var t = props.t;
        _this.state = { open: false };
        _this.loginPromise = null;
        _this.SocialLogin = socialLoginFactory(t);
        setRenewModal(_this);
        return _this;
    }
    RenewModal.prototype.render = function () {
        var _this = this;
        var _a = this.state, open = _a.open, _b = _a.openArgs, openArgs = _b === void 0 ? {} : _b;
        var _c = this.props, config = _c.config, authManager = _c.authManager, logo = _c.logo, tokens = _c.tokens;
        var fixedSocial = openArgs.fixedSocial, customComponent = openArgs.customComponent, upgradeRole = openArgs.upgradeRole, instantUpgradeRole = openArgs.instantUpgradeRole, redirectOnLogin = openArgs.redirectOnLogin, startTraditional = openArgs.startTraditional;
        var closer = openArgs.upgradeRole || openArgs.instantUpgradeRole
            ? this.upgradeCloseHandler
            : this.failedCloseHandler;
        return (React.createElement(Modal, { open: open }, function (_a) {
            var layout = _a.layout;
            return (React.createElement(React.Fragment, null,
                React.createElement("a", { href: "javascript:void(0)", onClick: closer },
                    React.createElement("span", { className: modalCloseIcon },
                        React.createElement(Icon, { name: 'close' }))),
                React.createElement(_this.SocialLogin, { authManager: authManager, onSuccess: _this.successfulLoginHandler, onClose: closer, tokens: tokens, isModal: true, config: config, logo: logo || config.LOGO, layout: layout === ModalLayouts.Compact
                        ? SOCIAL_LOGIN_LAYOUTS.COMPACT
                        : SOCIAL_LOGIN_LAYOUTS.STANDARD, 
                    // parametri relativi alla singola apertura della modal
                    fixedSocial: fixedSocial, customComponent: customComponent, upgradeRole: upgradeRole, instantUpgradeRole: instantUpgradeRole, forcedRenewAuthType: getLoginType(), startTraditional: startTraditional, redirectOnLogin: redirectOnLogin })));
        }));
    };
    return RenewModal;
}(Component));
export { RenewModal };
//# sourceMappingURL=RenewModal.js.map